import { permissions } from '../constants/permissions'

export const getRequiredUpdatePermissions = ({
  requiredPermissions = [permissions.SETTINGS_GENERAL_UPDATE],
  defaultTenant = false
}) => defaultTenant ? [permissions.DEFAULT_TENANT_SETTINGS_UPDATE] : requiredPermissions
